export default __webpack_public_path__ + "static/media/EXP_plus_5.7ef89b0c.gif";